/* ============================================================
   HERO BANNER V3 (hb3)
   - Binds Alia open action to the "First Time Customer" button
   - Safe for Theme Editor re-renders (section load/select)
   ============================================================ */

(function () {
  function bindHb3(root) {
    if (!root) return;

    // Only bind if the section is configured to use Alia
    var aliaEnabled = root.getAttribute("data-alia-enabled");
    if (aliaEnabled !== "true") return;

    var campaignId = parseInt(root.getAttribute("data-alia-campaign-id") || "", 10);
    if (!campaignId) return;

    var btn = root.querySelector(".hb3-firstTimeCustomer");
    if (!btn) return;

    // Prevent double-binding
    if (btn._hb3AliaBound) {
      btn.removeEventListener("click", btn._hb3AliaBound);
    }

    function handler(e) {
      e.preventDefault();
      e.stopPropagation();

      window.alia = window.alia || [];
      window.alia.push({
        type: "open",
        campaignID: campaignId,
        ignoreTargeting: true
      });
    }

    btn.addEventListener("click", handler);
    btn._hb3AliaBound = handler;
  }

  function initAll() {
    document.querySelectorAll(".hb3-sec[data-hb3]").forEach(function (root) {
      bindHb3(root);
    });
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Theme Editor dynamic loads
  document.addEventListener("shopify:section:load", function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var root = document.querySelector('.hb3-sec[data-hb3][data-section-id="' + e.detail.sectionId + '"]');
    bindHb3(root);
  });

  document.addEventListener("shopify:section:select", function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var root = document.querySelector('.hb3-sec[data-hb3][data-section-id="' + e.detail.sectionId + '"]');
    bindHb3(root);
  });
})();
